const keyFactory = {
  counter: 0,
  next() {
    return this.counter++; // eslint-disable-line no-plusplus
  },
};

export default keyFactory;
